import React, { useContext } from 'react';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Listing } from 'models/Listing';
import {
  getIsListSectionsRuleSatisfied,
  PUBLIC_LISTING_REQUIREMENT,
} from 'router/subrouters/ListingCreationWizard/data/publicListingRequirements';
import PreviewMissingFieldsContext from '../../providers/PreviewMissingFields/PreviewMissingFields.context';

import './ListSectionRuleNote.styles.scss';

/**
 * The two-of-three rule reads below each of Highlights, Products and Key
 * assets. No section is required on its own, so none gets a border and there is
 * no shared container or group heading - just a line under each list.
 */
const ListSectionRuleNote: React.FC = () => {
  const { t } = useTranslation();

  const { isMarked } = useContext(PreviewMissingFieldsContext);

  const { values } = useFormState<Partial<Listing>>({
    subscription: { values: true },
  });

  // Same two triggers as a required field: opened and left, or caught by
  // "Show missing fields".
  if (!isMarked?.(PUBLIC_LISTING_REQUIREMENT.LIST_SECTIONS)) return null;

  if (getIsListSectionsRuleSatisfied(values)) return null;

  return (
    <div className="list-section-rule-note">
      <p>{t('noteThat2Required')}</p>
    </div>
  );
};

export default ListSectionRuleNote;
